import {EEntityType} from 'shared/constants/entities';

export const entityTypeForRequest = (entityType: EEntityType) => entityType
    ?.replace(/_/g, '-')
    .toLowerCase();
